import React, { Component } from "react";
import { FirebaseProvider } from "../../laco-common/firebase/context";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import FormSubmissions from "../siteForms/FormSubmissions";
import { FIREWIRE_TENANT } from "../../laco-common/base/models/tenant";
import { firewireApp } from "../../firewire";
import { ISitePage } from "../../laco-common/base/models/page";
import CMSRoleProvider from "../../admin/contexts/cms-role/CMSRoleProvider";

class PSFormSubmissions extends Component<IAuthProps & { page: ISitePage }> {
	state = {
		loading: true,
		searchQuery: "",
		columnDefs: [],
	};

	render() {
		return (
			<FirebaseProvider
				value={{
					clientFirebase: firewireApp as any,
					firewireApp,
					tenant: FIREWIRE_TENANT,
					userPayload: this.props.authContext.userPayload,
				}}
			>
				<CMSRoleProvider>
					<FormSubmissions className="my-4 pb-2" page={this.props.page} fullWidth={this.props.page?.fullWidth} />
				</CMSRoleProvider>
			</FirebaseProvider>
		);
	}
}

export default withAuth(PSFormSubmissions);
